import type {
  AutomationKey,
  AutomationRun,
  AutomationSetting,
  UpdateAutomationInput,
} from '@peles/shared';
import { apiClient } from './client';

/** `/automations` — the messages the app sends by itself (ADMIN). */
const BASE = '/automations';

export async function listAutomations(): Promise<AutomationSetting[]> {
  const { data } = await apiClient.get<{ automations: AutomationSetting[] }>(BASE);
  return data.automations;
}

export async function updateAutomation(
  key: AutomationKey,
  input: UpdateAutomationInput,
): Promise<AutomationSetting> {
  const { data } = await apiClient.put<AutomationSetting>(`${BASE}/${key}`, input);
  return data;
}

export async function listAutomationRuns(limit = 100): Promise<AutomationRun[]> {
  const { data } = await apiClient.get<{ runs: AutomationRun[] }>(`${BASE}/runs`, {
    params: { limit },
  });
  return data.runs;
}
